import { render } from "./MessengerForm.vue?vue&type=template&id=0a6b4bc3&scoped=true"
import script from "./MessengerForm.vue?vue&type=script&lang=js"
export * from "./MessengerForm.vue?vue&type=script&lang=js"

import "./MessengerForm.vue?vue&type=style&index=0&id=0a6b4bc3&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6b4bc3"]])

export default __exports__